module.exports = __webpack_public_path__ + "media/2x/G-a5d2b7f1.png";